import React, { Component } from 'react'
import Plx from 'react-plx'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'
import theme from 'ui/styles/theme'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

import InfoBox from './InfoBox'

let scroll = [
  {
    start: '.electives-parallax-trigger',
    startOffset: '100vh',
    duration: '100vh',
    properties: [
      {
        startValue: 0,
        endValue: 0,
        unit: 'vw',
        property: 'translateX'
      }
    ]
  }
]

// Styles
const ModuleWrapper = styled.div`
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
  margin-bottom: 80px;
  padding: 0 0 0 20px;

  ${media.lg`
    padding: 0;
  `}

  ${media.xs`
    padding: 0;
  `}
`

const StickyContainer = styled.div`
  position: relative;

  ${media.lg`
    position: sticky;
    top: 0;
  `}
`

const StickyWrapper = styled.div`
  height: auto;

  ${media.lg`
    height: ${props => props.scrollArea}vh;
  `}
`

const Content = styled.div`
  overflow: hidden;
  height: auto;

  ${media.lg`
    height: 100vh;
  `}
`

const Title = styled.h2`
  font-size: 40px;
  line-height: 40px;
  margin-top: 0;

  ${media.xs`
    padding: 0 20px;
  `}

  ${media.lg`
    margin-top: ${props => props.theme.navHeight + 45}px;
  `}
`

const Text = styled.p`
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 65px;
  color: ${props => props.theme.colors.oxford.light};

  ${media.xs`
    padding: 0 20px;
  `}
`

const Images = styled.div`
  display: flex;
  padding-left: 15px;
  overflow: auto;

  ${media.lg`
    overflow: visible;
    padding-left: calc(8.333333vw + 45px);
  `}
`

const Slide = styled(Link)`
  width: 45vw;
  height: 55vh;
  flex-shrink: 0;
  background-size: cover;
  background-image: url(${props => props.image});
  background-position: center;
  overflow: visible;
  position: relative;

  &:last-child {
    margin-right: 15px;
  }

  ${media.xs`
    width: 70vw;
    height: 60vh;
  `}
  
  ${media.lg`
    width: 28vw;
    height: 70vh;
  
    &:last-child {
      margin-right: 0;
    }
  `}
`

const SlideTitle = styled.p`
  font-size: 28px;
  line-height: 30px;
  color: ${props => props.theme.colors.grey.lightest};
  text-align: center;
  text-transform: uppercase;
  font-family: ${props => props.theme.displayFont};
  font-weight: 600;
  margin-top: 25px;

  ${media.xs`
    padding: 0 10px;
  `}
`

export default class Electives extends Component {
  state = {
    scrollArea: 100,
    disableParallax: false
  }
  
  componentDidMount() {
    this.calcScroll()
  }

  calcScroll() {
    const length = this.props.content.length
    const heightPerSlide = 40
    const scrollArea = heightPerSlide * length
    const disableParallax = window.innerWidth <= 992
    const slideWidth = disableParallax ? -80 : -28

    this.setState({
      scrollArea,
      disableParallax
    })

    scroll[0].properties[0].duration = `${scrollArea}vh`

    if(window.innerWidth <= 575) {
      scroll[0].properties[0].endValue = (slideWidth * (length - 1)) + ((30 / window.innerWidth) * 100)
    } else {
      scroll[0].properties[0].endValue = (slideWidth * (length - 3)) - 8.333333 + ((60 / window.innerWidth) * 100)
    }
  }
  
  render() {
    const {
      title,
      leadIn,
      content,
      showInfobox,
      infoImage,
      infoTitle,
      infoText,
      infoLink,
    } = this.props

    const {
      scrollArea,
      disableParallax
    } = this.state

    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <ModuleWrapper>
          <StickyWrapper scrollArea={scrollArea}>
            <div className="electives-parallax-trigger" />
            <StickyContainer>
              <Content>
                <Container fluid>
                  <Row>
                    <Col
                      sm={7}
                      smOffset={1}
                    >
                      <Title>{title}</Title>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      sm={7}
                      smOffset={1}
                    >
                      <Text>{leadIn}</Text>
                    </Col>
                  </Row>
                </Container>
                  <Plx
                    parallaxData={scroll}
                    disabled={disableParallax}
                  >
                    <Images>
                      {content.map((slide, index) => {
                        return(
                          <Slide
                            key={index}
                            image={slide.image.sourceUrl}
                            to={getRelativeUrl(slide.link)}
                            color={theme.colors[slide.color].base}
                          >
                            <SlideTitle>{slide.title}</SlideTitle>
                          </Slide>
                        )
                      })}
                    </Images>
                  </Plx>
              </Content>
            </StickyContainer>
          </StickyWrapper>
          
          {showInfobox &&
            <InfoBox
              image={infoImage.sourceUrl}
              title={infoTitle}
              text={infoText}
              link={infoLink}
            />
          }
          
        </ModuleWrapper>
      </InViewMonitor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Electives/index.js